module.exports = __webpack_public_path__ + "static/img/jom.0996ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jom.jpg
// module id = qven
// module chunks = 0